$(document).ready(function () {
	$('.video--random').each(function( ) {
        var randomNumber = Math.floor(Math.random() * 11);
        var newUrlMobile = $(this).attr('data-mobile') + `#t=${randomNumber}`;
        var newUrlLarge = $(this).attr('data-large') + `#t=${randomNumber}`;
        $(this).attr('data-mobile', newUrlMobile);
        $(this).attr('data-large', newUrlLarge);
    });

    initVideoCover();

    $( window ).resize(function() {
    initVideoCover();
    });



});



/* INIT VIDEOS */
function initVideoCover() {
	$('.initVideo').each(function () {
		var video = $(this);
		var size;
		if (window.matchMedia('(max-width:580px), (orientation: portrait)').matches) {
			size = 'mobile';
		} else {
			size = 'large';
		}
		video.append("<source src='" + $(video).data(size) + "' type='video/mp4'>");
	});
}
/* END INIT VIDEOS */


